<form [formGroup]="attributeTypeForm">
  <div class="row">
    <div class="col-md-6 mb-3">
      <!-- <label for="" class="form-label">Product List</label>
    <ng-select class="ng-select-md" placeholder="Select" [appendTo]="'body'">
      <ng-option selected>THD</ng-option>
    </ng-select> -->
      <generic-dropdown
        [items]="productList$ | async"
        [label]="'Product List'"
        [placeholder]="'Select Product List'"
        [required]="true"
        [allowSearch]="true"
        [clearable]="false"
        [errormessage]="'Product List is required'"
        formControlName="productListId"
      >
      </generic-dropdown>
    </div>
    <div class="col-md-6 mb-3">
      <!-- <label for="" class="form-label">Category</label>
    <ng-select class="ng-select-md" placeholder="Select" [appendTo]="'body'">
      <ng-option selected>THD</ng-option>
    </ng-select> -->
      <generic-dropdown
        [items]="category$ | async"
        [label]="'Category'"
        [placeholder]="'Select Category'"
        [required]="true"
        [allowSearch]="true"
        [clearable]="false"
        [errormessage]="'Category is required'"
        formControlName="categoryId"
      >
      </generic-dropdown>
    </div>
    <div class="col-md-6 mb-3">
      <!-- <label for="" class="form-label">Subcategory</label>
    <ng-select class="ng-select-md" placeholder="Select" [appendTo]="'body'">
      <ng-option selected>THD</ng-option>
    </ng-select> -->
      <generic-dropdown
        [items]="subcategory$ | async"
        [label]="'Subcategory'"
        [placeholder]="'Select Subcategory'"
        [required]="true"
        [allowSearch]="true"
        [clearable]="false"
        [errormessage]="'Subcategory is required'"
        formControlName="subcategoryId"
      >
      </generic-dropdown>
    </div>
    <div class="col-md-6 mb-3">
      <!-- <label for="" class="form-label">Attribute Type <span class="text-danger fs-12">*</span></label>
    <ng-select class="ng-select-md" placeholder="Select" [appendTo]="'body'">
      <ng-option selected>THD</ng-option>
    </ng-select> -->
      <label class="form-label">Attribute Type</label><span class="text-danger"> *</span>
      <div class="w-100">
        <p-autoComplete
          formControlName="name"
          [suggestions]="attributeTypeSuggestions()"
          (completeMethod)="onAttributeTypeSearch($event)"
          (onSelect)="onAttributeTypeSelect()"
          [minLength]="3"
          styleClass="w-100"
          [dropdown]="false"
          [forceSelection]="false"
          [placeholder]="'Enter Attribute Type'"
        ></p-autoComplete>
        @if (attributeTypeForm.get('name')?.touched && attributeTypeForm.get('name')?.invalid) {
          <div class="text-danger">
            <span>Attribute Type is required</span>
          </div>
        }
      </div>
    </div>
    <div class="col-md-6 mb-3">
      <div class="d-flex align-items-center gap-2">
        <p class="mb-1 fs-16">Validate</p>
        <p-toggleswitch formControlName="validate" class="lh-1" />
      </div>
    </div>
  </div>
</form>
